// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"61df57d2","582":"71534d20"}[chunkId] + ".chunk.js";
};